<template>
  <div class="order-recommend-product-prompt-message">
    <layout :title="title"
            :content="content"
            :show-recommend="products.length > 0"
            hint="推荐你加入以下课程"
    >
      <product-list class="recommend-list"
                    :list="products"
      />
      <template #bottom>
        <customer-service v-if="contact"
                          showConsultBtn
                          title="学习顾问"
                          consult-string="微信联系"
                          tel-string="电话联系"
                          qr-code-title="微信联系学习顾问"
                          qr-code-hint="专业顾问团队为你答疑"
                          :qrCode="contact.qrCode"
        />
      </template>
    </layout>

  </div>
</template>

<script>
  import Layout from '@/pages/Common/components/OrderRecommendLayout';
  import ProductList from '@/components/ProductList/List';
  import CustomerService from '@/components/CustomerService';
  import validator from '@/utils/validator';

  export default {
    name: 'OrderRecommendProduct',
    components: {
      Layout,
      ProductList,
      CustomerService,
    },
    props: {
      title: {
        type: String,
        required: true,
      },
      content: {
        type: String,
        required: true,
      },
      products: {
        type: Array,
      },
      contact: {
        validator(val) {
          return validator.isObject(val);
        },
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';
  .recommend-list {
    text-align: left;
    margin: 0 -@size-base;
  }
</style>
